import { gql } from "@apollo/client";
import { DEDUCTION_FRAGMENT } from "./deductionFragment";

const GET_DEDUCTION_BY_DEDUCTION_ID = gql`
  ${DEDUCTION_FRAGMENT}
  query GetDeductionByDeductionID($params: GetDeductionByDeductionIDParams!) {
    deduction(params: $params) {
      ...DeductionFields
    }
  }
`;

export default GET_DEDUCTION_BY_DEDUCTION_ID;
